import { FileRepository } from '../Domain/Repository/files.repository';

export class FileUserCase {
  private fileRepository = new FileRepository();

  public async invokeUploadFile(d: FormData) {
    return this.fileRepository.uploadExcel(d);
  }
}
